import * as DashboardUtils from '../../Dashboards/DashboardUtils';
import moment from 'moment';
import * as workspaces from '../../../config/WorkspaceConstants';

export default function homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) {
    let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
    let timeZone = moment.tz.guess();
    let franchise; let client; let bodyJSON; let technology;
    if (workspace === workspaces.automation_ops) {
        franchise = dashboardFilterSelectionsAutomation.franchise;
        client = dashboardFilterSelectionsAutomation.client;
        bodyJSON = {
            "filters": {
                "time": {
                    "startDateTime": timeFilterSelections.startDateTime,
                    "endDateTime": timeFilterSelections.endDateTime
                },
                "franchises": franchise,
                "clients": client,
            },
            "interval": {
                "calender_Interval": calenderInterval,
                "time_zone": timeZone
            },
            "workspace": workspace,
        };
    }
    else if (workspace === workspaces.salesforce_ops) {
        //technology = dashboardFilterSelectionsSalesforce.technology;
        franchise = dashboardFilterSelectionsSalesforce.franchise;
        client = dashboardFilterSelectionsSalesforce.client;
        bodyJSON = {
            "filters": {
                "time": {
                    "startDateTime": timeFilterSelections.startDateTime,
                    "endDateTime": timeFilterSelections.endDateTime
                },
                "franchises": franchise,
                "clients": client,
            },
            "interval": {
                "calender_Interval": calenderInterval,
                "time_zone": timeZone
            },
            "workspace": workspace,
            "entity": entity
        };
    }
    else if (workspace === workspaces.sap_ops) {
        franchise = dashboardFilterSelectionsSAP.franchise;
        client = dashboardFilterSelectionsSAP.client;
        bodyJSON = {
            "filters": {
                "time": {
                    "startDateTime": timeFilterSelections.startDateTime,
                    "endDateTime": timeFilterSelections.endDateTime
                },
                "franchises": franchise,
                "clients": client,
            },
            "interval": {
                "calender_Interval": calenderInterval,
                "time_zone": timeZone
            },
            "workspace": workspace
        };
    }
    return bodyJSON;
}